import Swiper from 'swiper';
import { Navigation, Autoplay, FreeMode } from 'swiper/modules';

import 'swiper/css/bundle';


export default () => {
	const rows = [...document.querySelectorAll('.logo-carousel__row')];

	rows.forEach((rowEl) => {
		const carouselEl = rowEl.querySelector('.logo-carousel');
		const carouselPrev = rowEl.querySelector('.swiper-carousel__prev');
		const carouselNext = rowEl.querySelector('.swiper-carousel__next');

		if (!carouselEl) return;

		// --- 1) Swiper for layout + nav only (no autoplay/loop) ---
		const config = {
			modules: [Navigation],
			slidesPerView: 2.5,
			spaceBetween: 24,
			allowTouchMove: false,     
			speed: 450,
			loop: false,

			breakpoints: {
				1124: { 
					slidesPerView: 4.6,
					slidesPerGroup: 1
					
				},
				1650: { 
					slidesPerView: 5.5,
					slidesPerGroup: 1
				},
			},
		};
		if (carouselPrev || carouselNext) {
			config.navigation = { nextEl: carouselNext, prevEl: carouselPrev };
		}

		const swiper = new Swiper(carouselEl, config);
		const wrapper = swiper.wrapperEl;

		// --- 2) Duplicate track so wrapping is invisible ---
		function resetDuplicates() {
			wrapper.querySelectorAll('.swiper-slide[data-dup]').forEach((node) => node.remove());
		}

		function markOriginals() {
			wrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
				if (!slide.hasAttribute('data-orig') && !slide.hasAttribute('data-dup')) {
					slide.setAttribute('data-orig', '');
				}
			});
		}

		function duplicateUntilWideEnough() {
			const minFactor = 2.2; // build track > 2× container width
			const containerWidth = swiper.el.clientWidth;

			let contentWidth = wrapper.scrollWidth;
			const originals = [...wrapper.querySelectorAll('.swiper-slide[data-orig]')];

			// Always duplicate at least once so we can wrap seamlessly.
			if (originals.length && !wrapper.querySelector('.swiper-slide[data-dup]')) {
				originals.forEach((node) => {
					const clone = node.cloneNode(true);
					clone.removeAttribute('data-orig');
					clone.setAttribute('data-dup', '');
					wrapper.appendChild(clone);
				});
				contentWidth = wrapper.scrollWidth;
			}

			while (contentWidth < containerWidth * minFactor) {
				originals.forEach((node) => {
					const clone = node.cloneNode(true);
					clone.removeAttribute('data-orig');
					clone.setAttribute('data-dup', '');
					wrapper.appendChild(clone);
				});
				contentWidth = wrapper.scrollWidth;
			}
			return contentWidth;
		}

		// --- 3) Measurements + ticker state ---
		let wrapSpan = 0;      // width of one full original set
		let x = 0;             // current translateX
		let running = true;
		let last = performance.now();
		let pxPerSec = 60;     // ← tweak continuous speed here

		function measureOneSetWidth() {
			const originals = [...wrapper.querySelectorAll('.swiper-slide[data-orig]')];
			if (!originals.length) return 0;
			const first = originals[0];
			const lastOriginal = originals[originals.length - 1];
			const firstStyles = window.getComputedStyle(first);
			const lastStyles = window.getComputedStyle(lastOriginal);
			const start = first.offsetLeft - (parseFloat(firstStyles.marginLeft) || 0);
			const end = lastOriginal.offsetLeft
				+ lastOriginal.offsetWidth
				+ (parseFloat(lastStyles.marginRight) || 0);
			return Math.max(0, end - start);
		}

		function layout() {
			wrapSpan = measureOneSetWidth();
		}

		function refresh() {
			stopTicker();
			wrapper.style.transform = 'translate3d(0,0,0)';
			x = 0;
			resetDuplicates();
			markOriginals();
			duplicateUntilWideEnough();
			layout();
			startTicker();
		}

		function tick(now) {
			if (!running) return;
			const dt = (now - last) / 1000;
			last = now;

			x -= pxPerSec * dt;           // leftward motion
			if (x <= -wrapSpan) x += wrapSpan; // jump by exactly one set (invisible)

			wrapper.style.transition = 'none';
			wrapper.style.transform = `translate3d(${x}px,0,0)`;

			requestAnimationFrame(tick);
		}

		function startTicker() {
			running = true;
			last = performance.now();
			requestAnimationFrame(tick);
		}
		function stopTicker() { running = false; }

		// --- 4) Init after Swiper sized things ---
		function whenImagesReady(cb) {
			const images = [...wrapper.querySelectorAll('img')];
			if (!images.length) {
				cb();
				return;
			}
			let remaining = images.length;
			const done = () => {
				remaining -= 1;
				if (remaining <= 0) cb();
			};
			images.forEach((img) => {
				if (img.complete) return done();
				img.addEventListener('load', done, { once: true });
				img.addEventListener('error', done, { once: true });
			});
		}

		function init() {
			markOriginals();
			duplicateUntilWideEnough();
			layout();
			startTicker();
		}
		if (document.readyState === 'complete' || document.readyState === 'interactive') {
			setTimeout(() => whenImagesReady(init), 0);
		} else {
			document.addEventListener('DOMContentLoaded', () => whenImagesReady(init));
		}

		// --- 5) Resize handling (debounced) ---
		let resizeTimer;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				refresh();
			}, 150);
		});

		window.addEventListener('load', refresh);

		// --- 6) Optional: pause on hover ---
		swiper.el.addEventListener('mouseenter', stopTicker);
		swiper.el.addEventListener('mouseleave', () => { if (!running) startTicker(); });

		// --- 7) Navigation “nudges” instead of slideNext/Prev ---
		function nudge(bySlides = 1) {
			const originals = wrapper.querySelectorAll('.swiper-slide[data-orig]');
			const count = originals.length || 1;
			const step = (wrapSpan / count) * bySlides + (swiper.params.spaceBetween || 0) * bySlides;

			stopTicker();

			x -= step;                    // nudge left for next; negative bySlides nudges right
			if (x <= -wrapSpan) x += wrapSpan;
			if (x >= 0) x -= wrapSpan;    // keep x within (-wrapSpan, 0] to avoid visual jumps

			wrapper.style.transition = 'none';
			wrapper.style.transform = `translate3d(${x}px,0,0)`;

			setTimeout(startTicker, 50);
		}

		if (carouselNext) {
			carouselNext.addEventListener('click', (e) => { e.preventDefault(); nudge(+1); });
		}
		if (carouselPrev) {
			carouselPrev.addEventListener('click', (e) => { e.preventDefault(); nudge(-1); });
		}

		// Expose per-row controls if needed (optional)
		rowEl.__logoCarousel = {
			swiper,
			pause: () => stopTicker(),
			resume: () => startTicker(),
			setSpeed: (v) => { pxPerSec = Math.max(1, +v || 1); },
			reverse: (dir = -1) => { pxPerSec = Math.abs(pxPerSec) * (dir < 0 ? 1 : -1); }
		};
	});
};